import { Box, Button, H1, Icon, Link, Text } from '@betterment/samba-react';

import { FirmLogo } from '../../components/FirmLogo';
import BackgroundImage from '../../images/gradient_x.png?url';
import { navigate } from '../../utils/path-helpers';

interface InProgressErrorPageTemplateProps {
  returnAddress: string;
  headerText: string;
  titleText: string;
  bodyText: string;
}

export const ErrorPageHeader = ({ returnAddress, headerText }: InProgressErrorPageTemplateProps) => (
  <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
    <Box css={{ display: 'flex', alignItems: 'center' }}>
      <FirmLogo />
      <Box
        css={{
          borderLeftWidth: 'thin',
          borderLeftStyle: 'solid',
          borderLeftColor: 'border',
          width: 'size.1',
          height: 'size.250',
          mx: 'space.200',
        }}
      />
      <Text
        css={{
          justifySelf: 'center',
        }}
        variant="text50"
        color="text.weak"
      >
        {headerText}
      </Text>
    </Box>
    <Box>
      <Link aria-label="Exit" href={returnAddress}>
        <Icon name="X" size="small" color="icon" mode="decorative" />
      </Link>
    </Box>
  </Box>
);

export const AdvisorErrorPage = ({
  returnAddress,
  headerText,
  bodyText,
  titleText,
}: InProgressErrorPageTemplateProps) => {
  return (
    <Box css={{ display: 'flex', height: 'lvh' }}>
      <Box css={{ backgroundColor: 'grey', alignItems: 'center', display: 'flex', flex: '1.25' }}>
        <img src={BackgroundImage} alt="" />
      </Box>
      <Box css={{ px: 'space.800', pt: 'space.400', flex: '2' }}>
        <ErrorPageHeader returnAddress={returnAddress} headerText={headerText} bodyText="" titleText="" />
        <H1
          css={{
            mt: 'space.800',
            maxWidth: '472px',
          }}
          variant="title400"
        >
          {titleText}
        </H1>
        <Box
          css={{
            mt: 'space.200',
            mb: 'space.600',
            maxWidth: '520px',
          }}
        >
          <Text variant="text100">{bodyText}</Text>
        </Box>
        <Button variant="solidSecondary" onClick={() => navigate(returnAddress)}>
          Done
        </Button>
      </Box>
    </Box>
  );
};
